const Core = require('./core');

module.exports = {
  startSession: Core.boot,
};
